import { z } from 'zod';

export const certificateFormSchema = z.object({
  cn: z
    .string()
    .min(1, 'CN을 입력하세요')
    .max(255, '최대 255자'),
  sni: z.string().max(255, '최대 255자').optional(),
  expiresAt: z.string().optional(),
  fingerprint: z.string().max(128, '최대 128자').optional(),
  certPem: z.string().optional(),
  keyPem: z.string().optional(),
  metadata: z.record(z.unknown()).optional(),
  enabled: z.boolean().default(true),
});

export type CertificateFormValues = z.infer<typeof certificateFormSchema>;
